"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PlayerInfoCard } from "../partials/PlayerInfoCard";
import { PlayerSeasonHighlights } from "../partials/PlayerSeasonHighlights";
import { PlayerRecentForm } from "../partials/PlayerRecentForm";
import { PlayerMatchHighlight } from "../partials/PlayerMatchHighlight";
import { LatestNewsGrid } from "@/components/articles/LatestNewsGrid";
import { usePlayerPageData } from "../context/PlayerPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
const OVERVIEW_ARTICLES_LIMIT = 3;
export const OverviewTab: React.FC = () => {
  const $ = _c(11);
  const labels = useLabels().playerPage;
  const {
    getArticles
  } = usePlayerPageData();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section><PlayerInfoCard /></section>;
    t1 = <section><PlayerSeasonHighlights /></section>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getArticles) {
    t2 = getArticles().slice(0, OVERVIEW_ARTICLES_LIMIT);
    $[2] = getArticles;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== labels.news.latestNews || $[5] !== t2) {
    t3 = <LatestNewsGrid articles={t2} title={labels.news.latestNews} />;
    $[4] = labels.news.latestNews;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section><div className="grid grid-cols-1 lg:grid-cols-2 gap-6"><PlayerMatchHighlight type="latest" /><PlayerMatchHighlight type="upcoming" /></div></section>;
    t5 = <section><PlayerRecentForm /></section>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3) {
    t6 = <div className="space-y-8">{t0}{t1}{t3}{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};